module.exports = __webpack_public_path__ + "img/logo.530270a3.png";